<template>
  <div>
    <va-dashboard-filter></va-dashboard-filter>
    <div v-if="this.detailMode !== ''">
      <component v-bind:is="bindDetail" :mode="this.filterMode" :fetchData="this.fetchData"></component>
    </div>
    <div v-else-if="this.layoutMode === '1'">
      <div class="row">
        <div class="col-md-12">
          <va-main-eri :mode="this.filterMode" :fetchData="this.fetchData"></va-main-eri>
        </div>
      </div>
      <va-summary-warehouse :mode="this.filterMode" :fetchData="this.fetchData"></va-summary-warehouse>
    </div>
    <div v-else-if="this.layoutMode === '2'">
      <div class="row">
        <div class="col-md-6">
          <component v-bind:is="bindService" :mode="this.filterMode" :fetchData="this.fetchData"></component>
        </div>
        <div class="col-md-6">
          <va-main-eri :mode="this.filterMode" :fetchData="this.fetchData"></va-main-eri>
        </div>
      </div>      
      <va-summary-warehouse :mode="this.filterMode" :fetchData="this.fetchData"></va-summary-warehouse>
    </div>
    <div v-else-if="this.layoutMode === '3'">
      <div class="row">
        <div class="col-md-4">
          <va-summary-td :mode="this.filterMode" :fetchData="this.fetchData"></va-summary-td>
        </div>
        <div class="col-md-4">
          <va-summary-transport :mode="this.filterMode" :fetchData="this.fetchData"></va-summary-transport>
        </div>
        <div class="col-md-4">
          <va-main-eri :mode="this.filterMode" :fetchData="this.fetchData"></va-main-eri>
        </div>
      </div>
      
      <va-summary-warehouse :mode="this.filterMode" :fetchData="this.fetchData"></va-summary-warehouse>
    </div>
  </div>
</template>

<script>
import constants from 'assets/js/constants.js'
import { mapGetters, mapActions } from 'vuex'
import DashboardFilter from 'components/dashboard/DashboardFilter.vue'
import TemporaryDepositSummary from 'components/dashboard/TemporaryDepositSummary.vue'
import TransportSummary from 'components/dashboard/TransportSummary.vue'
import EriMain from 'components/dashboard/EriMain.vue'
import WarehouseSummary from 'components/dashboard/WarehouseSummary.vue'

export default {
  name: 'DashboardServices',
  data () {
    return {
      detailMode: '',
      bindService: '',
      layoutMode: '',
      filterMode: '',
      fetchData: null,
      loader: null
    }
  },
  computed: {
    ...mapGetters([
      'dashboardFilter'
    ]),
    bindDetail () {
      let component

      switch (this.detailMode) {
        case 'warehouse':
          component = 'va-summary-warehouse'
          break
        case 'temporaryDesposit':
          component = 'va-summary-td'
          break
        case 'transport':
          component = 'va-summary-transport'
          break
        default:
          component = ''
          break
      }

      return component
    }
  },
  created () {
    this.loader = this.$loading.show({
      loader: 'dots'
    })
    this.loader.hide()
    $('body').addClass('sidebar-collapse').trigger('collapsed.pushMenu')
  },
  methods: {
    ...mapActions([
      'fetchDashboardData'
    ]),
    filterRefresh () {
      this.loader = this.$loading.show({
        loader: 'dots',
        fullPage: true
      })

      if (this.dashboardFilter.mode === constants.dashboardFilterModes.date && this.dashboardFilter.startDate === this.dashboardFilter.endDate) {
        this.filterMode = constants.dashboardFilterModes.today
      } else {
        this.filterMode = this.dashboardFilter.mode
      }

      this.fetchDashboardData(this.dashboardFilter)
      .then((data) => {
        if (data != null) {
          this.fetchData = data
          /*
            1. warehouse
            2. temporaryDesposit
            3. transport
          */
          this.detailMode = ''

          /*
            1 = Eri & Warehouse
            2 = BindService (TD or Transport) + Eri & Warehouse
            3 = TD + Transport + Eri & Warehouse
          */

          if (this.dashboardFilter.client.hasTemporaryDepositService && this.dashboardFilter.client.hasTransportService) {
            this.layoutMode = '3'
          } else if (this.dashboardFilter.client.hasTemporaryDepositService) {
            this.layoutMode = '2'
            this.bindService = 'va-summary-td'
          } else if (this.dashboardFilter.client.hasTransportService) {
            this.layoutMode = '2'
            this.bindService = 'va-summary-transport'
          } else {
            this.layoutMode = '1'
          }

          this.loader.hide()
        }
      })
    },
    showDetail (detail) {
      this.detailMode = detail === undefined ? '' : detail
    }
  },
  components: {
    'va-dashboard-filter': DashboardFilter,
    'va-summary-td': TemporaryDepositSummary,
    'va-summary-transport': TransportSummary,
    'va-main-eri': EriMain,
    'va-summary-warehouse': WarehouseSummary
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>
.span-unit {
  font-weight: bold;
  color: grey;
}

.span-status {
  font-weight: bold;
  font-size: 12px;
}

.span-value {
  font-weight: bold;
  font-size: 18px;
}

.btn-detail {
  padding: 0.5px
}

.chartPadding {
  padding-left: 40px; 
  padding-right: 40px;
}
</style>



// WEBPACK FOOTER //
// DashboardServices.vue?297dee44